// constants.js
export const BASE_URL = process.env.REACT_APP_API_URL;
export const N8N_LOGIN_URL = `${BASE_URL}/webhook/auth/login`;
export const N8N_AI_PROXY_URL = `${BASE_URL}/webhook/ai-assistant`;
export const N8N_INCIDENTS_URL = `${BASE_URL}/webhook/client-incidents`;

export const colorMap = {
  emerald: { bg: 'bg-emerald-500/10', text: 'text-emerald-500', border: 'border-emerald-500/20', hover: 'group-hover:bg-emerald-500' },
  red: { bg: 'bg-red-500/10', text: 'text-red-500', border: 'border-red-500/20', hover: 'group-hover:bg-red-500' },
  indigo: { bg: 'bg-red-600/10', text: 'text-red-600', border: 'border-red-600/20', hover: 'group-hover:bg-red-600' },
  amber: { bg: 'bg-amber-500/10', text: 'text-amber-500', border: 'border-amber-500/20', hover: 'group-hover:bg-amber-500' },
};
